import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  customers,
  customersForm,
  visits,
  visitsForm,
  Offers,
  OffersForm,
  templates,
  templatesForm,
  emailusers,
  emailusersForm,
  products,
  productsForm,
  historics,
  historicsForm,
  notes,
  notesForm,
} from "./Reducers";

export default combineReducers({
  notes,
  notesForm,
  historics,
  historicsForm,
  products,
  productsForm,
  emailusers,
  emailusersForm,
  templates,
  templatesForm,
  Offers,
  OffersForm,
  visits,
  visitsForm,
  customers,
  customersForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
